import styled from 'styled-components'

export const CoverContainer = styled.div`
  background: ${(p) => p.theme.colors.defaultArrow};
  border-radius: 16px;
  overflow: hidden;
`
